import { createApi } from '@reduxjs/toolkit/query/react'
import { sendNotification } from 'components'
import axiosBaseQuery from 'services/axiosBaseQuery'
import { GenericResponse, TableRequestV3, TableResponseV2 } from 'services/types'
import { IntegrationReportSource, IntegrationReportType } from './types'

export const integrationsApi = createApi({
  reducerPath: 'integrationsApi',
  tagTypes: ['IntegrationRecordList'],
  baseQuery: axiosBaseQuery({
    baseUrl: `${window.envVariables.REACT_APP_BASE_URL + '/int-api'}`,
  }),
  endpoints: (builder) => ({
    getIntegrationRecords: builder.query<TableResponseV2<{}>, TableRequestV3>({
      query: ({ clientId, ...data }) => ({
        url: `/integrations/${clientId}/list/`,
        method: 'POST',
        data,
      }),
      providesTags: ['IntegrationRecordList'],
    }),
    startBagSync: builder.mutation<
      GenericResponse,
      { clientId: number; report_type: IntegrationReportType; source: IntegrationReportSource }
    >({
      query: ({ clientId, ...data }) => ({
        url: `/integrations/${clientId}/`,
        method: 'POST',
        data,
      }),
      async onQueryStarted(_, { queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          // `onSuccess` side-effect
          sendNotification({
            type: 'success',
            toastContent: data.detail.message,
          })
        } catch (err) {
          // `onError` side-effect
        }
      },
      invalidatesTags: ['IntegrationRecordList'],
    }),
  }),
})
